/* Native details supplies click, touch and Enter/Space behaviour without JS. */
if (!customElements.get('vk-account-navigation')) {
  customElements.define('vk-account-navigation', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const { signal } = this.listeners;
      const details = this.querySelector('details');
      const summary = details?.querySelector('summary');
      if (!details || !summary) return;

      const syncExpanded = () => summary.setAttribute('aria-expanded', String(details.open));
      const close = () => { details.open = false; syncExpanded(); };
      syncExpanded();
      details.addEventListener('toggle', syncExpanded, { signal });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          summary.focus();
        } else if (event.target === summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault();
          details.open = true;
          syncExpanded();
          const links = this.querySelectorAll('.vk-account__link');
          const link = event.key === 'ArrowDown' ? links[0] : links[links.length - 1];
          link?.focus();
        }
      }, { signal });

      document.addEventListener('pointerdown', (event) => {
        if (details.open && !this.contains(event.target)) close();
      }, { signal });

      document.addEventListener('focusin', (event) => {
        // A null blur target can occur while a link is being pressed. Wait for
        // an explicit outside focus target so the link can finish activating.
        if (details.open && !this.contains(event.target)) close();
      }, { signal });
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }
  });
}
